// Chat Assistant Constants - DEV-2105

export const CHAT_ASSISTANT_ENDPOINTS = {
  EVALUATION_ASSISTANT_MESSAGE: '/ai/evaluation-assistant/message',
  TRANSCRIBE_AUDIO: '/ai/evaluation-assistant/transcribe',
  CHAT_ASSISTANT_DRAFTS: '/recruitsessiondraft/chat-assistant',
  ASSISTANT_THREAD: '/ai/assistant/thread',
};

export const CHAT_ASSISTANT_DEFAULTS = {
  QUESTION_TYPE: 'TEXT_AI',
  LANGUAGE: 'es',
  DRAFTS_LIMIT: 15,
  DRAFTS_OFFSET: 0,
  EXAMPLE_QUESTIONS_COUNT: 3,
  PROCTORING_ENABLED: false,
  PROCTORING_AI_ENABLED: false,
  ALLOW_CERTIFICATE_DOWNLOAD: true,
  REQUIRE_COMPLETED_PROFILE: false,
  EVALUATION_REDIRECT_DELAY: 1500,
  PROGRESS_PERCENTAGE_INITIAL: 0,
  PROGRESS_PERCENTAGE_COMPLETE: 100,
  COOLDOWN_SECONDS: 30,
  MAX_ATTEMPTS: 3,
};

export const CHAT_ASSISTANT_MESSAGES = {
  NO_THREAD_TO_DELETE: 'No thread to delete',
  THREAD_ALREADY_DELETED: 'Thread already deleted or not found',
  DRAFT_ALREADY_DELETED: 'Draft already deleted',
};

export const FORMDATA_HEADERS = {
  MULTIPART_FORM_DATA: 'multipart/form-data',
};

export const ERROR_STATUSES = {
  RATE_LIMIT: 429,
  UNAUTHORIZED: 401,
  NOT_FOUND: 404,
  SERVER_ERROR: 500,
};

export const AUDIO_CONFIG = {
  AUDIO_TYPE: 'audio/wav',
  AUDIO_FILENAME: 'audio.wav',
  AUDIO_CONSTRAINTS: { audio: true },
};

export const EVALUATION_DEFAULTS = {
  DEFAULT_DURATION: 60,
  DEFAULT_PURPOSE: 'OTHER',
  DEFAULT_REVIEW_TYPE: 'GLOBAL',
  DEFAULT_CATEGORY_ID: 'CUSTOM',
  DEFAULT_WEIGHT: 100,
  DEFAULT_MAX_SCORE: 100,
  DEFAULT_ORDER: 0,
  DAYS_TO_ADD: 30,
  MILLISECONDS_PER_DAY: 24 * 60 * 60 * 1000,
  IS_ELIMINATORY: false,
  HAS_SKIP_QUESTION: false,
  ENABLED: true,
  IS_AUTOMATIC_CONTINUE: true,
  WITHOUT_TIME: false,
};

export const CONFETTI_CONFIG = {
  PARTICLE_COUNT: 150,
  SPREAD: 70,
  ORIGIN_Y: 0.6,
  DELAY: 500,
};
